import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component({})
export default class DialogTemplate extends Vue {
    @Prop({ default: false }) progressLinear!: string

    get fitContent() {
        return this.$attrs.hasOwnProperty('fit-content')
    }

    get canClose() {
        return this.$attrs.persistent !== '' && this.$attrs.persistent !== 'true'
    }

    menu = true

    @Watch('menu')
    trackMenu() {
        if (!this.menu) {
            this.$emit('closeDialog')
        }
    }
}
